import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({
  description = '',
  lang = 'en',
  meta = [],
  title,
  image,
  pathname = '',
  article = false,
  noindex = false,
  nofollow = false,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            defaultImage
            social {
              twitter
            }
          }
        }
      }
    `
  );

  const siteMetadata = site.siteMetadata || {};
  const metaDescription = description || siteMetadata.description;
  const defaultTitle = siteMetadata.title;
  const normalizedPathname =
    pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
  const canonicalUrl =
    siteMetadata.siteUrl && normalizedPathname
      ? new URL(normalizedPathname, siteMetadata.siteUrl).toString()
      : siteMetadata.siteUrl || undefined;

  const imagePath = image || siteMetadata.defaultImage;
  const imageUrl = imagePath
    ? imagePath.startsWith('http')
      ? imagePath
      : siteMetadata.siteUrl
      ? new URL(imagePath, siteMetadata.siteUrl).toString()
      : imagePath
    : undefined;

  const robotsDirectives = [
    noindex ? 'noindex' : 'index',
    nofollow ? 'nofollow' : 'follow',
  ].join(', ');

  const baseMeta = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      name: `robots`,
      content: robotsDirectives,
    },
    {
      property: `og:title`,
      content: title || defaultTitle,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: article ? `article` : `website`,
    },
    {
      property: `og:url`,
      content: canonicalUrl,
    },
    {
      property: `og:image`,
      content: imageUrl,
    },
    {
      name: `twitter:card`,
      content: `summary_large_image`,
    },
    {
      name: `twitter:creator`,
      content: siteMetadata?.social?.twitter || ``,
    },
    {
      name: `twitter:title`,
      content: title || defaultTitle,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
    {
      name: `twitter:image`,
      content: imageUrl,
    },
  ].filter((tag) => tag.content);

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      defaultTitle={defaultTitle}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      link={canonicalUrl ? [{ rel: 'canonical', href: canonicalUrl }] : []}
      meta={baseMeta.concat(meta)}
    />
  );
};

export default Seo;
